import { OptionBadge } from './OptionBadge';
import type { OptionItem } from '../types';

interface OptionBadgeGroupProps {
  options: OptionItem[];
  selected: string[];
  onChange: (selected: string[]) => void;
  multiple?: boolean;
}

export function OptionBadgeGroup({
  options,
  selected,
  onChange,
  multiple = true,
}: OptionBadgeGroupProps) {
  const handleToggle = (id: string) => {
    if (multiple) {
      // Multi select — toggle el item
      const next = selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id];
      onChange(next);
    } else {
      // Single select — reemplaza la selección
      onChange(selected[0] === id ? [] : [id]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2.5">
      {options.map((option) => (
        <OptionBadge
          key={option.id}
          option={option}
          selected={selected.includes(option.id)}
          onToggle={handleToggle}
        />
      ))}
    </div>
  );
}
